//
// Module for the Fund Employer Reporting Transmittal Schedules - Edit view
//
rs.module("content/fund/account/employerreportingtransmittalschedules/edit",

    [
        "common/visibility",
        "jobs/schedule-editor"
    ],

    function (visibility, scheduleEditor) {

        // Initialize the module
        function initialize(jsSelectors, batchSelectionTypes, selectedBatchesGrid) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var batchSelectionType = form.js(jsSelectors.batchSelectionType);
            var selectedBatchesRow = form.js(jsSelectors.selectedBatchesRow);
            var selectedBatchesErrorMessage = form.js(jsSelectors.selectedBatchesErrorMessage);

            // batch selection type change handler
            batchSelectionType.change(function () {

                // wipe grid selected values
                selectedBatchesGrid.selectedValues = null;

                // wipe any grid errors
                selectedBatchesErrorMessage.text('');

                // show/hide the selected batches grid row and update the available recurrence basis options
                // schedules configured to run for "Selected Batches" cannot be recurring (even though the job itself allows recurring schedules)
                if ($(this).val() == batchSelectionTypes.selected) {
                    visibility.show(selectedBatchesRow);
                    scheduleEditor.setRecurrenceBasis(false);
                }
                else {
                    visibility.hide(selectedBatchesRow);
                    scheduleEditor.setRecurrenceBasis(true);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);